import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { ASC, VIEW } from "const"
import { RrsTemplate } from "server/models"
import {
    PRM_RRS_TEMPLATE,
    StoreType,
    SortRrsTemplate,
    SetDefaultProjectRrsTemplate,
} from "client/store"
import { hasProjectAccess } from "client/utils"
import {
    Container,
    PageForm,
    FormGroup,
    DivInput,
    Empty,
    Label,
    SelectDropdown,
    SelectDropdownItem,
    Delimiter,
} from "client/components"

import TemplateView from "client/pages/rrs/template/templateView"

const Default = () => {
    const templateList = useSelector((state: StoreType) => state.rrsTemplate.templateList)
    const project = useSelector((state: StoreType) => state.project.projectView)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const [sortedIds, setSortedIds] = useState<number[]>([])
    const [defaultTemplate, setDefaultTemplate] = useState<RrsTemplate>(null)

    useEffect(() => {
        const sorted = SortRrsTemplate(Object.values(templateList), "name", ASC, {})
        setSortedIds(sorted)

        const defaultTemplates = Object.values(templateList).filter((row) => row.default)
        if (defaultTemplates.length === 1) {
            setDefaultTemplate(defaultTemplates[0])
        } else if (
            sorted.length > 0
            && templateList[sorted[0]]
            && templateList[sorted[0]].projectId === project.id
        ) {
            changeDefault(templateList[sorted[0]])
        }
    }, [templateList])

    const changeDefault = (template: RrsTemplate) => {
        SetDefaultProjectRrsTemplate(template.id, project.id)
        .then(() => {
            setDefaultTemplate(null)
            setTimeout(() => {
                setDefaultTemplate(template)
            }, 0)
        })
    }

    const viewAccess = hasProjectAccess(PRM_RRS_TEMPLATE, VIEW)

    return (
        <Container>
            <PageForm noPaddingBottom>
                <Row>
                    <Col xs={12}>
                        <FormGroup>
                            <Label>{lang.defaultTemplate}</Label>
                            {
                                sortedIds.length === 0
                                && <DivInput widePadding row><Empty /></DivInput>
                            }
                            {
                                sortedIds.length === 1
                                && <DivInput widePadding row>{defaultTemplate ? defaultTemplate.name : <Empty />}</DivInput>
                            }
                            {
                                sortedIds.length > 1 && (
                                    <SelectDropdown title={defaultTemplate ? defaultTemplate.name : <Empty />}>
                                        {
                                            sortedIds && sortedIds.map((templateId) => {
                                                const template = templateList[templateId]
                                                if (template) {
                                                    return (
                                                        <SelectDropdownItem
                                                            key={template.id}
                                                            onClick={() => changeDefault(template)}
                                                        >
                                                            {template.name}
                                                        </SelectDropdownItem>
                                                    )
                                                }
                                                return null
                                            })
                                        }
                                    </SelectDropdown>
                                )
                            }
                        </FormGroup>
                        <Delimiter size="md" />
                    </Col>
                </Row>
            </PageForm>
            {
                defaultTemplate && viewAccess
                && <TemplateView templateId={defaultTemplate.id} />
            }
        </Container>
    )
}
export default Default
